import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "login__input" }
const _hoisted_4 = { class: "login__submit" }
const _hoisted_5 = { class: "login__tg" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "login__text" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "login__login" }
const _hoisted_10 = { class: "login__input" }
const _hoisted_11 = { class: "login__submit" }
const _hoisted_12 = { class: "login__tg" }
const _hoisted_13 = { class: "login__hint" }

import { computed } from 'vue'
import { i18n } from '@/locales/i18n'
import { getAxiosErrorText } from '@/common/helpers'

// Store
import { useAuthModalStore, useCommonStore } from '@/store'

import Button from '@/components/ui/Button'
import Title from '@/components/ui/Title'
import InputText from '@/components/inputs/InputText'
import { ElNotification } from 'element-plus'
import { api } from '@/network'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const modalStore = useAuthModalStore()
const commonStore = useCommonStore()

// Components
const isLoginValid = computed<boolean>(() => Boolean(modalStore.login?.login && modalStore.login?.login?.length >= 2))
const isCodeValid = computed<boolean>(() => Boolean(modalStore.login?.code && modalStore.login?.code?.length >= 4))

// Methods
function showError(e: any): void {
  ElNotification({
    title: i18n.t('common.error'),
    message: getAxiosErrorText(e),
    type: 'error',
  })
}

async function tryToCheckLogin() {
  modalStore.loading = true
  try {
    await modalStore.checkLogin(modalStore?.login?.login as string)
    modalStore.login.screen = 'code'
  } catch (e) {
    showError(e)
  } finally {
    modalStore.loading = false
  }
}

async function tryToCheckCode() {
  modalStore.loading = true
  try {
    const token = (await modalStore.checkCode(modalStore?.login?.login as string, modalStore?.login?.code as string)).data.token
    localStorage.setItem('token', token)
    api.http.setToken(token)
    const user = await commonStore.getUser(token)
    commonStore.user = user
    modalStore.$reset()
  } catch (e) {
    showError(e)
  } finally {
    modalStore.loading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Title), {
      class: "login__title",
      theme: ['modal', 'centered']
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('loginModal.title')), 1)
      ]),
      _: 1
    }),
    (_unref(modalStore).login.screen === 'index')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(tryToCheckLogin, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(InputText), {
              focus: "",
              theme: "tg",
              name: "login",
              modelValue: _unref(modalStore).login.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(modalStore).login.login) = $event)),
              label: _ctx.$t('loginModal.login')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Button), {
              theme: ['stretched', 'huge'],
              disabled: !isLoginValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('loginModal.getCode')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Button), {
              type: "a",
              theme: "tg",
              href: _ctx.$t('common.buttons.chat.link')
            }, {
              append: _withCtx(() => [
                _createVNode(_component_draw_svg, {
                  name: "tg",
                  width: "18",
                  height: "18"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.chat.title')) + " ", 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(modalStore).login.screen === 'code')
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _withModifiers(tryToCheckCode, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t('loginModal.text')) + " ", 1),
            _createElementVNode("a", {
              href: _ctx.$t('common.bot.link')
            }, "@" + _toDisplayString(_ctx.$t('common.bot.name')), 9, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('loginModal.useLogin')) + ": @" + _toDisplayString(_unref(modalStore).login.login), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(InputText), {
              name: "code",
              focus: "",
              modelValue: _unref(modalStore).login.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(modalStore).login.code) = $event)),
              label: _ctx.$t('loginModal.getCode')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Button), {
              theme: ['stretched', 'huge'],
              disabled: !isCodeValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('loginModal.confirm')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Button), {
              type: "a",
              theme: "tg",
              href: _ctx.$t('common.buttons.chat.link')
            }, {
              append: _withCtx(() => [
                _createVNode(_component_draw_svg, {
                  name: "tg",
                  width: "18",
                  height: "18"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.chat.title')) + " ", 1)
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('loginModal.hint')), 1)
        ], 40, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}
}

})